// @ helpers
const { formatText } = require('core/i18n').i18n;

const getCardsPreContractPdfData = () => {
    return {
        'open_credit': {
            preContractPdfLink: [
                {
                    fileName: "ContractProvision",
                    url: "https://www.openbank.es/assets/static/pdf/Pie%20de%20P%C3%A1gina/Contrato%20de%20prestacion%20de%20servicios%20de%20personas%20fisicas.pdf"
                }
            ],
            preContractPdfTitle: formatText('preContractDocument-preContractDocument_cardOpenCreditPdfTitle'),
            preContractPdfFileName: "documentosTarjetadeCréditoOpenCredit.pdf"
        },
        'nrd_opencredit': {
            preContractPdfLink: [
                {
                    fileName: "ContractProvision",
                    url: "https://www.openbank.es/assets/static/pdf/Pie%20de%20P%C3%A1gina/Contrato%20de%20prestacion%20de%20servicios%20de%20personas%20fisicas.pdf"
                }
            ],
            preContractPdfTitle: formatText('preContractDocument-preContractDocument_cardNerudaPdfTitle'),
            preContractPdfFileName: "documentosTarjetadeCréditoNeruda.pdf"
        },
        'open_debit': {
            preContractPdfTitle: formatText('preContractDocument-preContractDocument_cardOpenDebitPdfTitle'),
            preContractPdfFileName: "documentosTarjetadeDébitoOpenDebit.pdf"
        },
        'virtual_credit': {
            preContractPdfLink: [
                {
                    fileName: "ContractProvision",
                    url: "https://www.openbank.es/assets/static/pdf/Pie%20de%20P%C3%A1gina/Contrato%20de%20prestacion%20de%20servicios%20de%20personas%20fisicas.pdf"
                }
            ],
            preContractPdfTitle: formatText('preContractDocument-preContractDocument_cardVirtualCreditPdfTitle'),
            preContractPdfFileName: "documentosTarjetadeCréditoVirtualCredit.pdf"
        },
        'virtual_debit': {
            preContractPdfLink: [
                {
                    fileName: "ContractProvision",
                    url: "https://www.openbank.es/assets/static/pdf/Pie%20de%20P%C3%A1gina/Contrato%20de%20prestacion%20de%20servicios%20de%20personas%20fisicas.pdf"
                }
            ],
            preContractPdfTitle: formatText('preContractDocument-preContractDocument_cardVirtualDebitPdfTitle'),
            preContractPdfFileName: "documentosTarjetadeDébitoVirtualDebit.pdf"
        },
        'via-T': {
            preContractPdfLink: [
                {
                    fileName: "ContractProvision",
                    url: "https://www.openbank.es/assets/static/pdf/Pie%20de%20P%C3%A1gina/Contrato%20de%20prestacion%20de%20servicios%20de%20personas%20fisicas.pdf"
                }
            ],
            preContractPdfTitle: formatText('preContractDocument-preContractDocument_cardViatPdfTitle'),
            preContractPdfFileName: "documentosVIA-T.pdf"
        },
        'prepaid_ecard': {
            preContractPdfTitle: formatText('preContractDocument-preContractDocument_eCardPdfTitle'),
            preContractPdfFileName: "documentosTarjetaPrepagoeCard.pdf"
        },
        'premium_pack_card': {
            preContractPdfLink: [
                {
                    fileName: "ContractProvision",
                    url: "https://www.openbank.es/assets/static/pdf/Pie%20de%20P%C3%A1gina/Contrato%20de%20prestacion%20de%20servicios%20de%20personas%20fisicas.pdf"
                }
            ],
            preContractPdfTitle: formatText('preContractDocument-preContractDocument_cardPremiumPackPdfTitle'),
            preContractPdfFileName: "documentosPackdeDébitoyCréditoPremium.pdf"
        },
        'diamond_pack_card': {
            preContractPdfLink: [
                {
                    fileName: "ContractProvision",
                    url: "https://www.openbank.es/assets/static/pdf/Pie%20de%20P%C3%A1gina/Contrato%20de%20prestacion%20de%20servicios%20de%20personas%20fisicas.pdf"
                }
            ],
            preContractPdfTitle: formatText('preContractDocument-preContractDocument_cardDiamondPackPdfTitle'),
            preContractPdfFileName: "documentosPackdeDébitoyCréditoDiamond.pdf"
        },
        'mini_card': {
            preContractPdfLink: [
                {
                    fileName: "ContractProvision",
                    url: "https://www.openbank.es/assets/static/pdf/Pie%20de%20P%C3%A1gina/Contrato%20de%20prestacion%20de%20servicios%20de%20personas%20fisicas.pdf"
                }
            ],
            preContractPdfTitle: formatText('preContractDocument-preContractDocument_miniCardPdfTitle'),
            preContractPdfFileName: "documentosTarjetadeDébitoMinicard.pdf"
        },
        'at_home_abroad_card': {
            preContractPdfLink: [
                {
                    fileName: "ContractProvision",
                    url: "https://www.openbank.es/assets/static/pdf/Pie%20de%20P%C3%A1gina/Contrato%20de%20prestacion%20de%20servicios%20de%20personas%20fisicas.pdf"
                }
            ],
            preContractPdfTitle: formatText('preContractDocument-preContractDocument_cardAtHomeAbroadPdfTitle'),
            preContractPdfFileName: "documentosTarjetaAtHomeAbroad.pdf"
        },
        'open_young_card_account_package': {
            preContractPdfLink: [
                {
                    fileName: "ContractProvision",
                    url: "https://www.openbank.es/assets/static/pdf/Pie%20de%20P%C3%A1gina/Contrato%20de%20prestacion%20de%20servicios%20de%20personas%20fisicas.pdf"
                },
                {
                    fileName: "DocumentProvisionChildPersonalData",
                    url: "https://www.openbank.es/assets/static/pdf/PieDePagina/Proteccion_Datos_Menor.pdf"
                }
            ],
            preContractPdfTitle: formatText('preContractDocument-preContractDocument_packOpenYoungPdfTitle'),
            preContractPdfFileName: "documentosPackdeTarjetayCuentaOpenYoung.pdf"
        },
        'revolving_card': {
            preContractPdfLink: [
                {
                    fileName: "ContractProvision",
                    url: "https://www.openbank.es/assets/static/pdf/Pie%20de%20P%C3%A1gina/Contrato%20de%20prestacion%20de%20servicios%20de%20personas%20fisicas.pdf"
                }
            ],
            preContractPdfTitle: formatText('preContractDocument-preContractDocument_revolvingCardPdfTitle'),
            preContractPdfFileName: "documentosTarjetaRevolving.pdf"
        },
        'solidaria_card': {
            preContractPdfLink: [
                {
                    fileName: "ContractProvision",
                    url: "https://www.openbank.es/assets/static/pdf/Pie%20de%20P%C3%A1gina/Contrato%20de%20prestacion%20de%20servicios%20de%20personas%20fisicas.pdf"
                }
            ],
            preContractPdfTitle: formatText('preContractDocument-preContractDocument_solidariaCardPdfTitle'),
            preContractPdfFileName: "documentosTarjetaSolidaria.pdf"
        },
        'open_young_card': {
            preContractPdfLink: [
                {
                    fileName: "ContractProvision",
                    url: "https://www.openbank.es/assets/static/pdf/Pie%20de%20P%C3%A1gina/Contrato%20de%20prestacion%20de%20servicios%20de%20personas%20fisicas.pdf"
                },
                {
                    fileName: "DocumentProvisionChildPersonalData",
                    url: "https://www.openbank.es/assets/static/pdf/PieDePagina/Proteccion_Datos_Menor.pdf"
                }
            ],
            preContractPdfTitle: formatText('preContractDocument-preContractDocument_cardOpenYoungPdfTitle'),
            preContractPdfFileName: "documentosTarjetaPrepagoOpenYoung.pdf"
        },
         'maestro_card': {
            preContractPdfTitle: formatText('preContractDocument-preContractDocument_cardMaestroPdfTitle'),
            preContractPdfFileName: "documentosTarjetadeDébitoMaestro.pdf"
        },
        'metallic_card': {
            preContractPdfTitle: formatText('preContractDocument-preContractDocument_cardMetallicPdfTitle'),
            preContractPdfFileName: "documentosTarjetadeDébitoMetálica.pdf"
        },
    }
};

module.exports = getCardsPreContractPdfData
